export default __webpack_public_path__ + "static/media/question_icon.0c4b3027.svg";